import api from '../api';

export const getValidationStatuses = async (projectId) => {
  const res = await api.get('/validation-statuses', { params: { projectId } });
  return res.data;
};

export const getPublicValidationStatuses = async (projectId) => {
  const res = await api.get('/validation-statuses/public', { params: { projectId } });
  return res.data;
};

export const getValidationStatus = async (id) => {
  const res = await api.get(`/validation-statuses/${id}`);
  return res.data;
};

export const createValidationStatus = async ({ name, description, projectId }) => {
  const res = await api.post('/validation-statuses', { name, description, projectId });
  return res.data;
};

export const updateValidationStatus = async (id, { name, description }) => {
  const res = await api.put(`/validation-statuses/${id}`, { name, description });
  return res.data;
};

export const deleteValidationStatus = async (id) => {
  const res = await api.delete(`/validation-statuses/${id}`);
  return res.data;
};
